module.exports = __webpack_public_path__ + "static/media/primary-light.7df8557f.svg";